import { render, staticRenderFns } from "./InventoryTracing.vue?vue&type=template&id=4278fd53"
import script from "./InventoryTracing.vue?vue&type=script&lang=js"
export * from "./InventoryTracing.vue?vue&type=script&lang=js"
import style0 from "./InventoryTracing.vue?vue&type=style&index=0&id=4278fd53&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4278fd53')) {
      api.createRecord('4278fd53', component.options)
    } else {
      api.reload('4278fd53', component.options)
    }
    module.hot.accept("./InventoryTracing.vue?vue&type=template&id=4278fd53", function () {
      api.rerender('4278fd53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/InventoryTracing.vue"
export default component.exports